import React from "react";
import { useTemplateForUser } from "../../../utils/yantraImageTemplate";

const isWinningYantra = (yantraId, winningIds) => {
  if (!Array.isArray(winningIds)) return false;
  const id = Number(yantraId);
  return winningIds.some((w) => Number(w) === id);
};

/**
 * Yantra rows for place-bet detail / print — template name & image for bet owner.
 */
export default function PlaceBetDetailYantraList({
  placeBetData,
  winningYantraIds = [],
  betUserId,
  enabled = true,
}) {
  const yantraList = placeBetData?.yantra_list;
  const { getYantraImageUrl, getYantraName } = useTemplateForUser(
    betUserId,
    enabled && !!betUserId,
  );

  if (
    !Array.isArray(yantraList) ||
    yantraList.filter((y) => Number(y.yantra_count) > 0).length === 0
  ) {
    return null;
  }

  return (
    <div className="pbm-detail-section">
      <div className="pbm-yantra-list">
        {yantraList.map((y, idx) => {
          const isWin = isWinningYantra(y.yantra_id, winningYantraIds);
          const rowTotal =
            Number(y.yantra_amount || 0) * Number(y.yantra_count || 0);
          const displayName =
            getYantraName(y.yantra_name, y.yantra_id) ||
            `Yantra ${y.yantra_id}`;
          const imgSrc = getYantraImageUrl(y.yantra_img, y.yantra_id);

          return (
            <div
              key={y?.yantra_id ?? idx}
              className={`pbm-yantra-row ${isWin ? "winning" : ""}`}
            >
              <div className="pbm-yantra-name">
                <img
                  src={imgSrc}
                  alt={displayName}
                  className="pbm-yantra-thumb"
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.src = getYantraImageUrl(null, y.yantra_id);
                  }}
                />
                <span className="pbm-yantra-name-text">{displayName}</span>
                {isWin ? (
                  <span className="pbm-yantra-name-winning">WINNER</span>
                ) : null}
              </div>
              <div className="pbm-yantra-calc">
                {Number(y.yantra_count || 0)} × {Number(y.yantra_amount || 0)}
              </div>
              <div className="pbm-yantra-total">₹{rowTotal}</div>
            </div>
          );
        })}
      </div>
      <div className="pbm-yantra-total-amount">
        <span className="pbm-yantra-total-amount-label">Total Amount:</span>
        <span className="pbm-yantra-total-amount-value">
          ₹{Number(placeBetData?.amount || 0).toFixed(2)}
        </span>
      </div>
    </div>
  );
}

/** Print layout — template names only */
export function PlaceBetPrintYantraGrid({ placeBetData, betUserId, enabled }) {
  const yantraList = placeBetData?.yantra_list;
  const { getYantraName } = useTemplateForUser(betUserId, enabled && !!betUserId);

  if (!Array.isArray(yantraList)) return null;
  const active = yantraList.filter((y) => Number(y.yantra_count) > 0);
  if (active.length === 0) return null;

  return (
    <div className="pbm-print-yantras">
      <h4>Yantra List</h4>
      <div className="pbm-print-yantra-grid">
        {active.map((y, idx) => (
          <div key={y?.yantra_id ?? idx} className="pbm-print-yantra-item">
            <span>
              {getYantraName(y.yantra_name, y.yantra_id) ||
                `Yantra ${y.yantra_id}`}{" "}
            </span>
            <span>
              {y.yantra_count} X ₹{y.yantra_amount}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
